import { IconBase64 } from "@synergy/icons";
import { Drawer, Flex } from "antd";
import { useState } from "react";
import styled from "styled-components";
import { isEmpty } from "../../../../utils/hooks/isEmpty";
import { RegisterDetailClusterView } from "../../../Pages/RegisterDetailClusterView";
import { RegisterDetailView } from "../../../Pages/RegisterDetailView";
import { Text } from "../../Atomics/Text";
import { MapCreateIncidentModal } from "../../Molecules/Map/MapCreateIncidentModal/MapCreateIncidentModal";

const DrawerContainer = styled.div`
  position: relative;
  width: 100%;

  .drawerStyle {
    position: absolute;
    top: 88px;
    height: -webkit-fill-available;
    right: 0;
  }
`;



const MapDrawer = ({ selectedPOI, selectedCluster, onCloseDrawer, openDrawer, selectedLayer, setSelectedPOI,
    redirectToDigitalTwin, addNewIncidentToMap
}) => {
    const [createIncidentModal, setCreateIncidentModal] = useState(false);

    return (
        <>
            <DrawerContainer id="drawer-container">
                <Drawer
                    title={selectedPOI ?
                        <Flex align="center" gap={10}>
                            <img src={IconBase64(selectedPOI)} width="40px" height="40px" alt="selected marker icon" />
                            <Text $fontSize="text_md">{selectedPOI.name}</Text>
                        </Flex>
                        : selectedCluster && !isEmpty(selectedCluster) ? Object.values(selectedCluster)?.flat()?.length + (selectedLayer === 'Incidents' ? ' Incidents' : ' Services') : ''}
                    onClose={onCloseDrawer}
                    open={openDrawer}
                    size={!selectedPOI ? null : 'large'}
                    getContainer={() => document.getElementById('drawer-container')}
                    mask={false}
                    // extra={ } //For extra buttons in title area
                    className={!selectedPOI ? "my-drawer drawerStyle" : 'drawerStyle'}
                >
                    {!selectedPOI ?
                        <RegisterDetailClusterView selectedCluster={selectedCluster} setSelectedPOI={(value) => setSelectedPOI(value)} selectedLayer={selectedLayer}
                            addNewIncidentToMap={addNewIncidentToMap}
                            isDrawerOpen={openDrawer}
                        />
                        : <RegisterDetailView selectedPOI={selectedPOI} setCreateIncidentModal={setCreateIncidentModal} redirectToDigitalTwin={redirectToDigitalTwin} />
                    }
                </Drawer>
            </DrawerContainer >

            <MapCreateIncidentModal
                selectedPOI={selectedPOI}
                isCreateIncidentModalOpen={createIncidentModal}
                setCreateIncidentModal={setCreateIncidentModal}
                mapClickCoordinates={{ lat: selectedPOI?.latitude, lng: selectedPOI?.longitude }}
                addNewIncidentToMap={addNewIncidentToMap} />
        </>
    )
}

export default MapDrawer;